import { DashboardQuery, InsightsQuery } from 'src/graphql/_generated';
import _ from 'lodash';
import moment from 'moment';

type Incident = NonNullable<
  NonNullable<NonNullable<InsightsQuery['assessment']>['scenarios'][number]['incidents']>[number]
>;

export const calculateMeanDaysBetween = (events: Incident[]) => {
  if (!events.length || events.length < 2) return null;

  const sortedEvents = _.orderBy(
    events.filter((e: Incident) => e.dateOfIncident),
    [(e: Incident) => moment(e.dateOfIncident).valueOf()],
    ['asc'],
  );

  if (sortedEvents.length < 2) return 0;

  const differences = [];
  for (let i = 1; i < sortedEvents.length; i++) {
    const daysDiff = moment(sortedEvents[i].dateOfIncident).diff(moment(sortedEvents[i - 1].dateOfIncident), 'days');
    if (daysDiff > 0) {
      differences.push(daysDiff);
    }
  }

  return differences.length ? Math.round(_.sum(differences) / differences.length) : 0;
};

export const getUniqueLinkedControlsCount = (assessment?: DashboardQuery['assessment']) => {
  const controlIds = new Set<string>();

  assessment?.scenarios?.forEach((scenario) => {
    scenario.riskManagementPlans?.forEach((plan) => {
      if (plan.control?.id) {
        controlIds.add(plan.control.id);
      }
    });
  });

  return controlIds.size;
};
